
const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

/**
 * Recursively flatten a nested object into dot-notation keys.
 * e.g. { nav: { home: 'Ana' } } → { 'nav.home': 'Ana' }
 * Already-flat string values are kept as-is.
 */
function flattenObject(
  obj: Record<string, unknown>,
  prefix = ''
): Record<string, string> {
  const result: Record<string, string> = {};
  for (const key of Object.keys(obj)) {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    const value = obj[key];
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(result, flattenObject(value as Record<string, unknown>, fullKey));
    } else {
      result[fullKey] = String(value ?? '');
    }
  }
  return result;
}

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }

    // Support both `export default` and named exports (e.g. `export const common`)
    const sources: Record<string, unknown>[] = [];

    if (module.default && typeof module.default === 'object') {
      sources.push(module.default as Record<string, unknown>);
    }

    // Collect all named exports except 'default'
    for (const exportKey of Object.keys(module)) {
      if (exportKey !== 'default' && typeof module[exportKey] === 'object') {
        sources.push(module[exportKey] as Record<string, unknown>);
      }
    }

    for (const source of sources) {
      const flat = flattenObject(source as Record<string, unknown>);
      messages[lang].translation = {
        ...messages[lang].translation,
        ...flat,
      };
    }
  }
});

export default messages;
